<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card >
      <div v-if="selected" >
       <div class="text-center">
        <div class="header1" >
              <h3>{{ selected.eventName }}</h3>
            </div>
            <br>
             <br>
              <br>
        </div>

        <form>
          <div class="etkinlikIcerigi" >
              <vs-title  back>Etkinlik İçeriği</vs-title>
            <v-divider  class="divider" inset></v-divider>
      
            <vs-row>
        
                      <vs-col vs-lg="8" vs-xs="12">
                          <vs-card >
                          <vs-select
                                label="Görev Ekle"
                                placeholder="Görevler"
                                class="taskbar"
                                label-placeholder="Autocomplete"
                                autocomplete
                                v-model="eventTask"
                                >
                                <vs-select-item :key="index" :value="item" :text="item" v-for="item,index in gorevler" />
                              </vs-select>
                            <br>
                          </vs-card>
                      </vs-col>

                        <vs-col vs-lg="4" vs-xs="12">
                                   <br> <br>
                                     <vs-button color="#32bebe"  @click="gorevEkle(eventTask)">Görevli Ekle</vs-button> 

                           
                         
                      </vs-col>
                </vs-row>

                 <br/> <br/>
       

        </div>

    
        
        </form>
        <div v-if="taskOff">
        <vs-error :errors="errors"></vs-error>

       

        <br/> <br/>

        <vs-button class="butonlar" color="#46c93a" @click="update">Güncelle</vs-button>
         <!--<vs-button class="butonlar" color="danger" @click="deleteItem">Sil</vs-button>-->
         
       
      </div>
        </div>
        
      <div v-else>
        <div slot="header">
          <vs-title back>Etkinlik Seçili Değil</vs-title>
        </div>

        <p>Etkinlik Seçiniz...</p>
      </div>
    </vs-card>
  </div>

</template>

<script>

  import Appeal from "@/libs/appeals/Appeal";
  import Folder from "@/libs/folders/Folder";
  import axios from "axios";
 import User from "@/libs/users/User";
 import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'

  export default {
    name: "appeals-show",
    title: "Etkinlik Görüntüle/Düzenle",
     
    data() {
      return {
        counthuman:0,
        countnature:0,
        countanimal:0,
       tempgorev:'',
       tempEgitim:'',
        tempJuri:'',
        eventTask:'',
        check1:null,
        check2:null,
        check3:null,
        check4:null,
        check5:null,
        check6:null,
        check7:null,
        check8:null,
        check9:null,
        check10:null,
        check11:null,
        check12:null,
        check13:null,
        check14:null,
        check15:null,
        check16:null,
        check17:null,

        checksos1:null,
        checksos2:null,
        checksos3:null,
        checksos4 : null,
        checksos5  :null,
        checksos6  :null,
        checksos7  :null,
        checksos8 :null,
        checksos9 :null,
        checksos10 :null,
        checksos11 : null,
        checksos12 :null,
        checksos13 : null,
        checksos14 : null,
        checksos15 :null,
        checksos16 :null,
        checksos17 :null,
        checksos18  : null,
        checksos19 : null,
        checksos20 : null,
        checksos21 : null,
        hangiSosyal:"",
        sosyallerArray:['İnsana Yönelik', 'Doğaya Yönelik', 'Hayvana Yönelik' ],
        insanaList:['Kadın',
                  	'Yaşlı',
                  	'Çocuk',
                  	'Yoksulluk',
                  	'Engelli',
                  	'Sağlık ve Spor',
                  	'Değerler',
                  	'Diğer (Kan Bağışı, Kitap Okuma, Okuma Yazma Seferberliği, Farkındalık Çalışmaları Gibi)'],
        dogayaList:['Ağaç Dikme',
                    'Atık Toplama',
                    'Geri Dönüşüm',
                   	'Enerji Tasarrufu',
                    	'Temiz Su',
                   	'Milli Park, Tabiat Anıtı',
                    'Çevre Düzenleme',
                    'Artık Materyalleri Yeniden Değerlendirme',
                    'Diğer …'],
        hayvanaList:['Barınak',
                     'Kedi, Köpek Evi',
                     'Askıda Yem-Mama-Kap',
                     'Diğer …'],
        messageeee: 'Hover Me!',
        activez: false,
        baskasiAdina: false,
        obj: new Appeal(),
        obj2: new Folder(),
        user: getUserFromStorage(),
        obj3: new User(),
        iliskiler:'',
        alinan:[],
        etkinlikler:[],
        kiminAdina:'',
        sosyaller:'',
        repeatnum:0,
        files: null,
        gorevsecimi:"",
        gorevliler:[],
        loading: false,
        taskOn: false,
        sustainable: false,
        social: false,
        fileUpload: false,
        taskOff: true,
        message: '',
        menu2: false,
        color1:"#c94c4c",
        color2:"#feb236",
        color3:"#82b74b",
        color4:"#c94c4c",
        color5:"#F65314",
        color6:"#00A1F1",
        color7:"#FFBB00",
        color8:"#c83349",
        color9:"#F65314",
        color10:"#e06377",
        color11:"#ffcc5c",
        color12:"#8b6f47",
        color13:"#405d27",
        color14:"#00A1F1",
        color15:"#82b74b",
        color16:"#035397",
        color17:"#36486b",
      popupActivo1:false,
      popupActivo2:false,
      popupActivo3:false,
      popupActivo4:false,
      popupActivo5:false,
      popupActivo6:false,
      popupActivo7:false,
      popupActivo8:false,
      popupActivo9:false,
      popupActivo10:false,
      popupActivo11:false,
      popupActivo12:false,
      popupActivo13:false,
      popupActivo14:false,
      popupActivo15:false,
      popupActivo16:false,
      popupActivo17:false,
      select1Normal:'',
      repeat:0,
      select1:[],
      selectedLanguages:[],
      langs:'',
      languages2:[
        {text: 'Türkçe', value: 'Türkçe'},
        {text: 'İngilizce', value: 'İngilizce'},
        {text: 'Almanca', value: 'Almanca'},
        {text: 'İtalyanca', value: 'İtalyanca'},
        {text: 'İspanyolca', value: 'İspanyolca'},
        {text: 'Fransızca', value: 'Fransızca'},
        {text: 'Arapça', value: 'Arapça'},
        
      ],
      options3:[
        {text: 'Konser', value: 'Konser'},
        {text: 'Sergi', value: 'Sergi'},
        {text: 'Tiyatro', value: 'Tiyatro'},
        {text: 'Sinema', value: 'Sinema'}
       
      ],
       gorevlerOncesi:[
         'Eğitim',
         'Araştırma',
         'Toplumsal Katkı',
         'Sanatsal Katkı',
       ],
       gorevlerEgitim:[
         'Üniversitede Jüri/Komite Üyeliği',
         'Üniversitede Öğrenci Danışmanlığı',
         'Üniversitede Ders Verme',
         'Üniversite Kurul Üyeliği',
         'Üniversite Kurul Üyeliği',
         'Diğer Üniversitelerde Jüri/Komite Üyeliği',
         'Diğer Üniversitelerde Öğrenci Danışmanlığı',
         'Diğer Üniversitelerde Ders Verme',
         'Diğer Kurum-Kuruluşlarda Kurul Üyeliği',
         'Bilim Kurulu Üyeliği',
         'Oturum Başkanlığı',
         'Davetli Konuşmacı',
       ],
       gorevlerEgitimJuri:[
          'Sanatsal Çalışmalarda Jüri Üyeliği',
         'Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri',
       ],
       gorevlerEgitimJuriSanatsal:[
          'Uluslararası Yarışmalarda Juri Uyeliği',
         'Ulusal Yarışmalarda Juri Uyeliği',
       ],
       gorevlerEgitimMimarlık:[
          'Uluslararası ve Ulusal Yarışmalarda Jüri Üyelikleri',
         'Kültür Bakanlığı Kültür ve Tabiat Varlıklarını Koruma Kurullarında En Az İki Yıllık Üyelik',
       ],
       gorevlerArastirma:[
          'Editörlük',
          'Dış Kaynaklı Proje',
          'Dış Kaynaklı Proje',
          'Bilimsel Kurul Üyeliği',
          'Saha Alanı Saha Araştırmaları'
       ],
       gorevlerToplumsalKatki:[
          'Kamu-Özel Sektör- Stk İş Birliği',
          'Medya',
          'Turizm İlişkili Faaliyetler /	Rehberlik',
          'Bankacılık ile İlişkili Faaliyetler /	Portföy',
          'Bankacılık ile İlişkili Faaliyetler /	Diğer',
          'Spor Faaliyetleri'
       ],
       gorevlerToplumsalKatkiSporFaal:[
          
            'Hakemlik',
            'Antrenörlük',
            'Temsilcilik',
            'Oyunculuk',

       ],
       gorevlerToplumsalKatkiKamu:[
          'Şirket Sahibi',
          'Şirket Yöneticisi',
          'Bilirkişilik',
          'Temsilcilik',
          'Özel/Kamu Kuruluşlarına Danışmanlık',
          'Sendikal Faaliyet /	Üyelik',
          'Sendikal Faaliyet /	Yöneticilik',
          'Danışmanlık'
       ],
       gorevlerToplumsalKatkiMedya:[
          'Üniversite Bünyesindeki Medya Mecraları',
          'Diğer Görsel İşitsel Medya Kuruluşları',
          'Diğer Basılı Medya Kuruluşları	(Dergi/Gazete Köşe Yazarı)',
          'Diğer Sosyal Medya Alanlarında (Sosyal Medya Etkileşim)',
          
       ],
       gorevlerToplumsalKatkiMedyaUniversiteBunyesi:[
          'Gazete (Basılı/Dijital) /	Atölye/Uygulama Birimi Sorumlusu',
          'Gazete (Basılı/Dijital) /	Haber Muhabiri',
          'Gazete (Basılı/Dijital) /	Sayfa Tasarımcı',
          'Gazete (Basılı/Dijital) /	Yayın Koordinatörü',

          'Gazete (Basılı/Dijital) /	Haber Müdürü',
          'Gazete (Basılı/Dijital) /	Görsel Yönetmen',
          'Gazete (Basılı/Dijital) /	Editör',
          'Gazete (Basılı/Dijital) /	Redaktör',

          'Radyo /	Haber Spiker',
          'Radyo /	Program Sunucusu',
          'Radyo /	Ses Kurgu',
          'Radyo /	Ses Montaj',
          'Radyo /	Reji (Teknik Masa)',
          'Radyo /	Atölye Sorumlusu',
          'Televizyon /	Reji',
          'Televizyon /	Yönetmen',
          'Televizyon /	Resim Seçici',
          'Televizyon /	Sesçi',
          'Televizyon /	Işıkçı',
          'Televizyon /	Kc Operatörü (Altyazı)',
          'Televizyon /	Kameraman',
          'Televizyon /	Teknik Yönetmen',
          'Televizyon /	Playout Operatörü',
          'Televizyon /	Atölye Sorumlusu',
          'Sosyal Medya /	Sosyal Medya Sorumlusu',
          'Dergi /	Yazı İşleri Müdürü',
          'Dergi /	Editör',
          'Dergi /	Editör Yardımcısı',
          'Dergi /	Yayın Kurulu Üyesi',

       ],
        gorevlerToplumsalKatkiMedyaDigerBaski:[
            'Yapımcı/Sunucu',
            'Konuk - (Radyo/Tv)'
        ],
        gorevlerToplumsalKatkiMedyaDigerBaski:[
            'Yapımcı/Sunucu',
            'Konuk - (Radyo/Tv)'
        ],   
        gorevlerSanatsalKatki:[
            'Kurgulama',
            'Senaryo Yazarlığı',
            'Metin Yazarlığı',
            'Şeflik',
            'Rejisörlük',
            'Solistlik',
            'Yapımcı',
            'Oyunculuk',
            'Kameraman',
            'Görsel Efekt',
            'Ses Tasarımı',
            'Seslendirme ',
            'Yönetmen Yardımcısı',
            'Görüntü Yönetmeni',
            'Foto Muhabir',
            'Grafik Tasarımcısı',
            'Danışmanlık',
            'Danışmanlık /	Öğrenci Çalışmaları',

        ], 
       
       gorevler:[
            'Eğitim',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Sanatsal Çalışmalarda Jüri Üyeliği',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Sanatsal Çalışmalarda Jüri Üyeliği /	Uluslararası Yarışmalarda',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Sanatsal Çalışmalarda Jüri Üyeliği /	Ulusal Yarışmalarda',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri /	Uluslararası ve Ulusal Yarışmalarda Jüri Üyelikleri',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri /	Kültür Bakanlığı Kültür ve Tabiat Varlıklarını Koruma Kurullarında En Az İki Yıllık Üyelik',
            'Eğitim /	Üniversitede Öğrenci Danışmanlığı',
            'Eğitim /	Üniversitede Ders Verme',
            'Eğitim /	Üniversite Kurul Üyeliği',
            'Eğitim /	Diğer Üniversitelerde Jüri/Komite Üyeliği',
            'Eğitim /	Diğer Üniversitelerde Öğrenci Danışmanlığı',
            'Eğitim /	Diğer Üniversitelerde Ders Verme',
            'Eğitim /	Diğer Kurum-Kuruluşlarda Kurul Üyeliği',
            'Eğitim /	Bilim Kurulu Üyeliği',
            'Eğitim /	Oturum Başkanlığı',
            'Eğitim /	Davetli Konuşmacı',

            //////////////////////////////////////////////
            'Araştırma ',
            'Araştırma /	Editörlük',
            'Araştırma /	Teknik Editör',
            'Araştırma /	Dil Editörü (Türkçe)',
            'Araştırma /	Yabancı Dil Editörü',
            'Araştırma /	Dil Editörü (Türkçe ve yabancı dil)',
            'Araştırma /	Yazım Editörü',
            'Araştırma /	Yazım ve Dil Editörü',
            'Araştırma /	Danışma Kurulu Üyesi',
            'Araştırma /	Alan Editörü',
            'Araştırma /	İstatistik Editörü',
            'Araştırma /	Mizanpaj Editörü',
            'Araştırma /	Teknik Editör',
            'Araştırma /	Dış Kaynaklı Proje',
            'Araştırma /	Bilimsel Kurul Üyeliği',
            'Araştırma /	Saha Alanı Saha Araştırmaları',
            ////////////////////////////////////////////
            'Toplumsal Katkı',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Şirket Sahibi',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Şirket Yöneticisi',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Bilirkişilik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Temsilcilik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Özel/Kamu Kuruluşlarına Danışmanlık',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Sendikal Faaliyet',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Sendikal Faaliyet /	Üyelik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Sendikal Faaliyet /	Yöneticilik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	 Danışmanlık',
            'Toplumsal Katkı /	Medya',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital)',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Atölye/Uygulama Birimi Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Haber Muhabiri',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Sayfa Tasarımcı',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Yayın Koordinatörü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Haber Müdürü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Görsel Yönetmen',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Editör',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Redaktör',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Haber Spiker',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Program Sunucusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Ses Kurgu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Ses Montaj',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Reji (Teknik Masa)',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Atölye Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Reji',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Yönetmen',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Resim Seçici',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Sesçi',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Işıkçı',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Kc Operatörü (Altyazı)',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Kameraman',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Teknik Yönetmen',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Playout Operatörü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Atölye Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları d.	Sosyal Medya',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları d.	Sosyal Medya /	Sosyal Medya Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Yazı İşleri Müdürü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Editör',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Editör Yardımcısı',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Yayın Kurulu Üyesi',
            'Toplumsal Katkı /	Medya /	Diğer Görsel İşitsel Medya Kuruluşları',
            'Toplumsal Katkı /	Medya /	Diğer Görsel İşitsel Medya Kuruluşları /	Yapımcı/Sunucu',
            'Toplumsal Katkı /	Medya /	Diğer Görsel İşitsel Medya Kuruluşları /	Konuk - (Radyo/Tv)',
            'Toplumsal Katkı /	Medya /	Diğer Basılı Medya Kuruluşları',
            'Toplumsal Katkı /	Medya /	Diğer Basılı Medya Kuruluşları /	Dergi/Gazete Köşe Yazarı',
            'Toplumsal Katkı /	Medya /	Diğer Sosyal Medya Alanlarında',
            'Toplumsal Katkı /	Medya /	Diğer Sosyal Medya Alanlarında /	Sosyal Medya Etkileşim',
            'Toplumsal Katkı /	Turizm İlişkili Faaliyetler',
            'Toplumsal Katkı /	Turizm İlişkili Faaliyetler /	Rehberlik',
            'Toplumsal Katkı /	Turizm İlişkili Faaliyetler /	……',
            'Toplumsal Katkı /	Bankacılık ile İlişkili Faaliyetler',
            'Toplumsal Katkı /	Bankacılık ile İlişkili Faaliyetler /	Portföy',
            'Toplumsal Katkı /	Bankacılık ile İlişkili Faaliyetler /	Diğer',
            'Toplumsal Katkı /	Spor Faaliyetleri',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Hakemlik',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Antrenörlük',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Temsilcilik',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Oyunculuk',
            //////////////////////////////////////////////////
            'Sanatsal Katkı',
            'Sanatsal Katkı /	Kurgulama',
            'Sanatsal Katkı /	Kurgulama /	Yönetmen',
            'Sanatsal Katkı /	Kurgulama /	Yardımcı Yönetmen',
            'Sanatsal Katkı /	Kurgulama /	Görüntü Yönetmeni',
            'Sanatsal Katkı /	Kurgulama /	Kameraman',
            'Sanatsal Katkı /	Kurgulama /	Kurgucu',
            'Sanatsal Katkı /	Kurgulama /	Sesçi',
            'Sanatsal Katkı /	Kurgulama /	Senarist',
            'Sanatsal Katkı /	Kurgulama /	Oyuncu',
            'Sanatsal Katkı /	Senaryo Yazarlığı',
            'Sanatsal Katkı /	Metin Yazarlığı',
            'Sanatsal Katkı /	Şeflik',
            'Sanatsal Katkı /	Rejisörlük',
            'Sanatsal Katkı /	Solistlik',
            'Sanatsal Katkı /	Yapımcı',
            'Sanatsal Katkı /	Oyunculuk',
            'Sanatsal Katkı /	Kameraman',
            'Sanatsal Katkı /	Görsel Efekt',
            'Sanatsal Katkı /	Ses Tasarımı',
            'Sanatsal Katkı /	Seslendirme ',
            'Sanatsal Katkı /	Yönetmen Yardımcısı',
            'Sanatsal Katkı /	Görüntü Yönetmeni',
            'Sanatsal Katkı /	Foto Muhabir',
            'Sanatsal Katkı /	Grafik Tasarımcısı',
            'Sanatsal Katkı /	Danışmanlık',
            'Sanatsal Katkı /	Danışmanlık /	Öğrenci Çalışmaları',

       
      ],
      paraBirimi:[
        {text: '₺ Türk Lirası', value: 'Türk Lirası'},
        {text: '$ Dolar', value: 'Dolar'},
        {text: '€ Euro', value: 'Euro'},
        {text: '£ Sterlin', value: 'Sterlin'}
       
      ],
      };
    },

    computed: {
      
      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      },

      errors() {
        return this.obj.form.errors
      },

      selected() {
        return this.obj.selected
      },
    },

    watch: {
      relations(val){

      },
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.message = 'Etkinlik Başarıyla Güncellendi!';
      },

      deleted(val) {
        if(val)
          this.$router.go(-1) // back
      },
    },

    methods: {
      secimSifirla(){
           if(this.hangiSosyal=="İnsana Yönelik"){
                this.selected.socials="" 
                this.sosyaller=""
                this.checksos9=null;
                this.checksos10=null;
                this.checksos11 = null;
                this.checksos12 = null;
                this.checksos13 = null;
                this.checksos14 = null;
                this.checksos15=null;
                this.checksos16=null;
                this.checksos17=null;
                this.checksos18 = null;
                this.checksos19 = null;
                this.checksos20 = null;
                this.checksos21 = null;
           }
            if(this.hangiSosyal=="Doğaya Yönelik"){
                this.selected.socials=""
                this.sosyaller=""
                this.checksos1=null;
                this.checksos2=null;
                this.checksos3=null;
                this.checksos4 = null;
                this.checksos5 = null;
                this.checksos6 = null;
                this.checksos7 = null;
                this.checksos8=null;
                this.checksos18 = null;
                this.checksos19 = null;
                this.checksos20 = null;
                this.checksos21 = null;
            }
             if(this.hangiSosyal=="Hayvana Yönelik"){
                this.selected.socials=""
                this.sosyaller=""
                this.checksos1=null;
                this.checksos2=null;
                this.checksos3=null;
                this.checksos4 = null;
                this.checksos5 = null;
                this.checksos6 = null;
                this.checksos7 = null;
                this.checksos8=null;
                this.checksos9=null;
                this.checksos10=null;
                this.checksos11 = null;
                this.checksos12 = null;
                this.checksos13 = null;
                this.checksos14 = null;
                this.checksos15=null;
                this.checksos16=null;
                this.checksos17=null;
             }
      },
    yazarKurum(){
        if(this.selected.inHouse=="Kurum İçi")
          return true;
        else 
          return false;
      },
       juriVar(){
        if(this.selected.juri=="Var")
          return true;
        else 
          return false;
      },
      ilgiliEtkinlik(){
        if(this.selected.insideOtherEvent=="Evet")
          return true;
        else 
          return false;
      },
       mouseover: function(){
      this.messageeee = 'Good!'
    },    
    mouseleave: function(){
      this.messageeee = 'Hover Me!'
    },
      openKullanicilar(){
          if(this.baskasiAdina==true)
              this.baskasiAdina=false
          else  
              this.baskasiAdina=true
      },
      
      onayla(){
           if(this.check1)
            this.iliskiler+='& YOKSULLUĞA SON '
          if(this.check2)
            this.iliskiler+='& AÇLIĞA SON '
          if(this.check3)
            this.iliskiler+='& SAĞLIK VE KALİTELİ YAŞAM '
          if(this.check4)
            this.iliskiler+='& NİTELİKLİ EĞİTİM '
          if(this.check5)
            this.iliskiler+='& TOPLUMSAL CİNSİYET EŞİTLİĞİ '
          if(this.check6)
            this.iliskiler+='& TEMİZ SU VE SANİTASYON '
          if(this.check7)
            this.iliskiler+='& ERİŞİLEBİLİR VE TEMİZ ENERJİ '
          if(this.check8)
            this.iliskiler+='& İNSANA YAKIŞIR İŞ VE EKONOMİK BÜYÜME '
          if(this.check9)
            this.iliskiler+='& SANAYİ, YENİLİKÇİLİK VE ALTYAPI '
          if(this.check10)
            this.iliskiler+='& EŞİTSİZLİKLERİN AZALTILMASI '
          if(this.check11)
            this.iliskiler+='& SÜRDÜRÜLEBİLİR ŞEHİRLER VE TOPLULUKLAR '
          if(this.check12)
            this.iliskiler+='& SORUMLU ÜRETİM VE TÜKETİM '
          if(this.check13)
            this.iliskiler+='& İKLİM EYLEMİ '
          if(this.check14)
            this.iliskiler+='& SUDAKİ YAŞAM '
          if(this.check15)
            this.iliskiler+='& KARASAL YAŞAM '
          if(this.check16)
            this.iliskiler+='& BARIŞ, ADALET VE GÜÇLÜ KURUMLAR '
          if(this.check17)
            this.iliskiler+='& AMAÇLAR İÇİN ORTAKLIKLAR '

            if(this.iliskiler!=null){
                  this.iliskiler=this.iliskiler.substring(2);
            }
                this.selected.relations=this.iliskiler
      },
      resetle(){
        this.check1=false
        this.check2=false
        this.check3=false
        this.check4=false
        this.check5=false
        this.check6=false
        this.check7=false
        this.check8=false
        this.check9=false
        this.check10=false
        this.check11=false
        this.check12=false
        this.check13=false
        this.check14=false
        this.check15=false
        this.check16=false
        this.check17=false
           this.iliskiler=""
        this.selected.relations=this.iliskiler
       
      },
      onayla2(){
          if(this.hangiSosyal=="İnsana Yönelik"){
           
             if(this.checksos1){
                        this.sosyaller+='& Kadın '

          }
          if(this.checksos2){
                        this.sosyaller+='& Yaşlı '

          }
          if(this.checksos3){
                        this.sosyaller+='& Çocuk '

          }
          if(this.checksos4){
                        this.sosyaller+='& Yoksulluk '

          }
          if(this.checksos5){
                        this.sosyaller+='& Engelli '

          }
          if(this.checksos6){
                        this.sosyaller+='& Sağlık ve Spor '

          }
          if(this.checksos7){
                        this.sosyaller+='& Değerler '

          }
          if(this.checksos8){
                        this.sosyaller+='& (İnsana Yönelik)Diğer (Kan Bağışı, Kitap Okuma, Okuma Yazma Seferberliği, Farkındalık Çalışmaları Gibi) '

          }
          this.sosyaller=this.sosyaller.substring(2)
          this.sosyaller="İnsana Yönelik: " + "("+this.sosyaller+")"
          }



           if(this.hangiSosyal=="Doğaya Yönelik"){
            
               if(this.checksos9){
                        this.sosyaller+='& Ağaç Dikme '

          }
          if(this.checksos10){
                        this.sosyaller+='& Atık Toplama '

          }
          if(this.checksos11){
                        this.sosyaller+='& Geri Dönüşüm '

          }
          if(this.checksos12){
                        this.sosyaller+='& Enerji Tasarrufu '

          }
          if(this.checksos13){
                        this.sosyaller+='& Temiz Su '

          }
          if(this.checksos14){
                        this.sosyaller+='& Milli Park, Tabiat Anıtı '

          }
          if(this.checksos15){
                        this.sosyaller+='& Çevre Düzenleme '

          }
          if(this.checksos16){
                        this.sosyaller+='& Artık Materyalleri Yeniden Değerlendirme '

          }
          if(this.checksos17){
                        this.sosyaller+='& (Doğaya Yönelik) Diğer … '

          }
           this.sosyaller=this.sosyaller.substring(2)
          this.sosyaller="Doğaya Yönelik: " + "("+this.sosyaller+")"
           }
         

           if(this.hangiSosyal=="Hayvana Yönelik"){
            
       
          if(this.checksos18){
                        this.sosyaller+='& Barınak '

          }
          if(this.checksos19){
                        this.sosyaller+= '& Kedi, Köpek Evi '

          }
          if(this.checksos20){
                        this.sosyaller+='& Askıda Yem-Mama-Kap '

          }
          if(this.checksos21){
                        this.sosyaller+='& (Hayvana Yönelik) Diğer … '

          }
           this.sosyaller=this.sosyaller.substring(2)
          this.sosyaller="Hayvana Yönelik: " + "("+this.sosyaller+")"
           }
          this.selected.socials=this.sosyaller
                
      },
      resetle2(){
        this.checksos1=null;
        this.checksos2=null;
        this.checksos3=null;
        this.checksos4 = null;
        this.checksos5 = null;
        this.checksos6 = null;
        this.checksos7 = null;
        this.checksos8=null;
        this.checksos9=null;
        this.checksos10=null;
        this.checksos11 = null;
        this.checksos12 = null;
        this.checksos13 = null;
        this.checksos14 = null;
        this.checksos15=null;
        this.checksos16=null;
        this.checksos17=null;
        this.checksos18 = null;
        this.checksos19 = null;
        this.checksos20 = null;
        this.checksos21 = null;
        
          this.sosyaller=""
          this.hangiSosyal=""
         this.selected.socials= ""
       
      },
      denemeClick(x,den){
            console.log(den+" "+x)
           
         
                 this.selected.gorevliler.splice(x, 1);

             
      },
      
       successUpload(){
      console.log("123123"+this.$vs)
    },
    gorevEkle(gorevdata){
     
      
      
        this.selected.gorevliler.push({ekleyen: this.user.adKullaniciAdi, kiminAdina: this.user.adKullaniciAdi, gorev: gorevdata});
     
       
    },
    

      
      get(id) {
        this.obj.get(id, true);
      },

      updatePublished(status) {
        this.obj.columns.published = status
        return this.update()
      },
       updateTask() {
        if(this.taskOn==true){
          console.log("tr")
          this.taskOn=false;
          this.taskOff=true;
        }
        else{
          this.taskOn=true;
          this.taskOff=false;
        }
      },
       updateFileArea() {
        if(this.fileUpload==true){
          console.log("tr")
          this.fileUpload=false;
          this.taskOff=true;
        }
        else{
         
          this.fileUpload=true;
          this.taskOff=false;
        }
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
      },
      updateSustain() {
        if(this.sustainable==true){
          console.log("tr")
          this.sustainable=false;
          this.taskOff=true;
          this.social=false;
        }
        else{
          this.social=false;
          this.sustainable=true;
          this.taskOff=false;
        }
        document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0;
      },
      updateSocial() {
        if(this.social==true){
          console.log("tr")
          this.social=false;
          this.taskOff=true;
           this.sustainable=false;
        }
        else{
          
          this.social=true;
          this.taskOff=false;
            this.sustainable=false;
        }
        document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0;
      },
    
      update() {
        this.loading = true
        console.log("id"+this.selected.id)
        this.obj.update(this.selected.id, true)
        flash({message: 'Görev Kaydedildi', alert: 'success'})
      },
      deleteItem() {
        this.loading = true
        this.obj.delete(this.selected.id)
      },
       uploadFile (event) {
        this.files = event.target.files
        },
        handleSubmit() {
          const formData = new FormData();
          for (const i of Object.keys(this.files)) {
            formData.append('files', this.files[i])
            
            var file = this.files[i];  
           var filename = file.name;
           filename=filename.toLowerCase().split(' ').join('-');
           console.log(filename)
          }
           formData.append('directory', this.selected.eventName)
           formData.append('dclass', 'etkinlik_bilgisi')
          this.obj2.columns.folder= this.selected.eventName+'&&&&&'+'etkinlik_bilgisi'+'&+&+&'+filename
           this.obj2.create()
          axios.post('https://eys.hacibayram.edu.tr:8081/api/file-upload', formData, {
          }).then((res) => {
            console.log(res)
          })
        },
         handleDown() {
          
         axios({
            url: 'https://eys.hacibayram.edu.tr:8081/api/download/'+'?name='+this.selected.eventName, 
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
         
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'etkinli_takip_son.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
             
        });
        }  
    },

    mounted() {
      this.message = '';
      
      this.get(this.$route.params.id);
       this.alinan= this.$route.params.parametre2
        this.etkinlikler= this.$route.params.parametre3

          if(this.$route.params.parametre4!=null)
            this.sosyaller= this.$route.params.parametre4
          if(this.$route.params.parametre5!=null)
            this.iliskiler= this.$route.params.parametre5
       
        
          console.log("ee"+this.sosyaller+"        "+this.iliskiler)
       
     
    }
  }
</script>

<style>
    
    #mouse {
   
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 280px;
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    text-align: center;
    color: #fff;
    background: #007db9;

  }
   .taskbar{
     width:80%
   }
    .taskbar2{
     width:50%
   }
   
  .edit-form {
    max-width: 70%;
    margin: auto;
  }
  .element11 {display:inline-block;margin-right:10px;} 
.element22 {display:inline-block;} 
.element3 {display:inline-block;margin-right:100px; border-style: solid;
  border-width: 5px;} 
.element4 {display:inline-block; border-style: solid;
  border-width: 5px;} 
.sayfa1 {margin-left:5%;} 
.etkinlikIcerigi{
  margin-left:5%;
}
.sayfa2 {margin-left:5%;} 
.mainTitle{
  font-size: 22px;
  color: #666;
  margin: 20px 10px 0px;
  padding: 0px 30px 0px 30px;
  text-align: center;
  
}
.butonOnay{
  display:inline-block;
  margin-left: 33%;
  width: 30%;
  color:white;
}
.butonOnay2{
  display:inline-block;
  margin-left: 33%;
  width: 30%;
  color:white;
}
.divider{
  background-color:#441468; height:7px; width:100%
}
.counter{
  max-width: 30%;
}
.para{
  display: inline-block;
}
.select{
  width:100% !important;
}
.xyz{
  width:100% !important;
}
.radio1{
  margin-left: 30%;
}
.radio2{
  margin-left: 5%;
}
.repeat {
  display: inline-block; /* the default for span */
 margin-left: 15%;
 
 

}
.adres {
  display: inline-block; /* the default for span */
  margin-left: 15%;
  width:30%;
}

.butonBoyut{
width:90%;
}
.katilimEtkinlikHedef{
  margin-left:20%;
}
.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}

.dosyaYukleme{
 margin-left:25%;
 width:30%;
}
.pop {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 2%;
  padding-left: 1%;
  color:white;
}
.pop2 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop3 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop4 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop5 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop6 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop7 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop8 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop9 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop10 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop11 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop12 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop13 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop14 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop15 {
  display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.pop16 {
display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 5%;
  padding-left: 5%;
  color:white;
}
.pop17 {
   display:inline-block;
  padding-top: 10px;
  padding-bottom: 3%;
  padding-right: 1%;
  padding-left: 1%;
  color:white;
}
.v-messages.theme--light{
  display:none;
}
.vs-component.vs-button.vs-button-null.vs-button-filled {
   
}
.dosyaTemaKonu{
  margin-left:36%;
}
.jlist{
  width: 40%;
}
.con-input-upload{
  height: 60px;
  width: 150px;
   content:'goodbye'; 
}
.vs-select--label{
  font-weight: bold;
}
.v-label.theme--light{
  font-weight: bold;
}
.input-select-con{
  font-weight: bold;
}
.vs-con-input{
  font-weight: bold;
}
.butonlar{
  margin-left:1%;
} 
.genelbm{
  margin-left:3%;
}
#parameter2{
   height:180px;
    width:180px;
  
    background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  border-radius: 10px;
  object-fit: cover;
}
.wdth{
  width:100%;
}

#parameter{
   height:180px;
    width:180px;
  
   
}
.theme--light.v-btn {
    color: #e6272d !important;
}

#parameterİliski{
   font-weight: bold;
   border-style: solid;
  border-width: 5px;
  margin-top:15px;
}
.iliskiBorder{
  border-style: solid;
  border-width: 2px;
  border-radius:5px;
 
}
.gorevtable{
  padding: 1%;
  border-style: solid;
  border-width: 2px;
  border-radius:5px;
}

.bmk{
    font-size:16px;

}
</style>